import { Variable } from "./Variable";

/**
 * Author: Mariam Bawa (mariam.bawa@mpac.ca)
 * Date Created: April 15, 2024
 * Context: Extract this dataclass into its own file for code readability and ease of access
 * Actions taken: Extracted this dataclass and updated all relevant dependencies
 */
export default interface IncomeUnitType {
  snapshotId: number | null | undefined,
  tenantId: number | null | undefined,
  tenantName: string | null | undefined,
  leaseStatusCode: string | null | undefined,
  leaseTypeCode: string | null | undefined,
  startDate: string | null | undefined,
  endDate: string | null | undefined,
  netLeasableArea: number | null | undefined,
  unitTypeCode: string | null | undefined,
  tenantUnitNumber: string | null | undefined,
  styleTypeCode: string | null | undefined,
  unitSubtypeCode: string | null | undefined,
  unitCount: number | null | undefined,
  unitHeight: number | null | undefined,
  unitFinishedPercent: number | null | undefined,
  floorLevel: string | null | undefined,
  furnishedFlag: boolean | null | undefined,
  bathCount: number | null | undefined,
  denFlag: boolean | null | undefined,
  renovatedUnitCount: number | null | undefined,
  vacantUnitCount: number | null | undefined,
  monthlyMarketRent: number | null | undefined,
  negotiatedDate: string | null | undefined,
  landLeaseFlag: boolean | null | undefined,
  percentRentGrossSale: number | null | undefined,
  annualRent: number | null | undefined,
  currentBaseRent: number | null | undefined,
  propertyTaxRecovery: number | null | undefined,
  operatingRecovery: number | null | undefined,
  freeRentMonth: number | null | undefined,
  tenantImprovement: number | null | undefined,
  stepUpDate1: string | null | undefined,
  stepUpRate1: number | null | undefined,
  stepUpDate2: string | null | undefined,
  stepUpRate2: number | null | undefined,
  stepUpDate3: string | null | undefined,
  stepUpRate3: number | null | undefined,
  stepUpDate4: string | null | undefined,
  stepUpRate4: number | null | undefined,
  includeInsuranceFlag: boolean | null | undefined,
  includeManagementFlag: boolean | null | undefined,
  includeMaintenanceFlag: boolean | null | undefined,
  includeHydroFlag: boolean | null | undefined,
  includeWaterFlag: boolean | null | undefined,
  includeHvacFlag: boolean | null | undefined,
  includePropertyTaxFlag: boolean | null | undefined,
  secondOccupantFee: number | null | undefined,
  monthlyActualRent: number | null | undefined,
  typicalCareRate: number | null | undefined,
  improvementId: number | null | undefined,
  designTypeCode: string | null | undefined,
  buildingIdNumber: string | null | undefined,
  tenancyTypeCode: string | null | undefined,
  confirmedFlag: boolean | null | undefined,
  validFlag: boolean | null | undefined,
  originalUnitId: number | null | undefined,
  occCode: string | null | undefined,
  unitId: number | null | undefined,
  priority: number | null | undefined,
  linkFlag: boolean | null | undefined,
  analysisFlag: string,
  analysisReviewedBy: string,
  analysisReviewedDate: string,
  carryForwardFlag: boolean,
  variables: Variable[],
  componentId: string | null | undefined,
  renovatedFlag: boolean,
  vacantFlag: boolean,
  affordableUnitFlag: boolean
}

export const getDefaultUnit = () => {
  return {
    snapshotId: null,
    tenantId: null,
    tenantName: null,
    leaseStatusCode: null,
    leaseTypeCode: null,
    startDate: null,
    endDate: null,
    netLeasableArea: null,
    unitTypeCode: null,
    tenantUnitNumber: null,
    styleTypeCode: null,
    unitSubtypeCode: null,
    unitCount: null,
    unitHeight: null,
    unitFinishedPercent: null,
    floorLevel: null,
    furnishedFlag: null,
    bathCount: null,
    denFlag: null,
    renovatedUnitCount: null,
    vacantUnitCount: null,
    monthlyMarketRent: null,
    negotiatedDate: null,
    landLeaseFlag: null,
    percentRentGrossSale: null,
    annualRent: null,
    currentBaseRent: null,
    propertyTaxRecovery: null,
    operatingRecovery: null,
    freeRentMonth: null,
    tenantImprovement: null,
    stepUpDate1: null,
    stepUpRate1: null,
    stepUpDate2: null,
    stepUpRate2: null,
    stepUpDate3: null,
    stepUpRate3: null,
    stepUpDate4: null,
    stepUpRate4: null,
    includeInsuranceFlag: null,
    includeManagementFlag: null,
    includeMaintenanceFlag: null,
    includeHydroFlag: null,
    includeWaterFlag: null,
    includeHvacFlag: null,
    includePropertyTaxFlag: null,
    secondOccupantFee: null,
    monthlyActualRent: null,
    typicalCareRate: null,
    improvementId: null,
    designTypeCode: null,
    buildingIdNumber: null,
    tenancyTypeCode: null,
    confirmedFlag: null,
    validFlag: null,
    originalUnitId: null,
    occCode: null,
    unitId: null,
    priority: null,
    linkFlag: null,
    analysisFlag: "X",
    analysisReviewedBy: localStorage.getItem("username") ?? "SYSTEM",
    analysisReviewedDate: (new Date().toISOString()),
    carryForwardFlag: false,
    variables: [],
    componentId: null,
    renovatedFlag: false,
    vacantFlag: false,
    affordableUnitFlag: false
  } as IncomeUnitType
}
